






























import { Vue, Component, Prop } from 'vue-property-decorator';
import { Surface, Typography, Picture } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';

import eventBus from '@/utils/eventBus';
import ModalOptions from '@/components/Modal/ModalOptions';

@Component({ components: { Surface, Typography, Picture, FilledButton } })
export default class ReferralCreationFeedbackModal extends Vue {
  onClose() {
    eventBus.$emit('closeModal');
  }

  goReferral() {
    this.$analytics({
      eventCategory: 'Referral Program | Success modal',
      eventAction: 'click',
      eventLabel: 'Clicked on the "See referral program" button'
    });

    this.onClose();
    this.$router.push('/referral-program');
  }
  get tPrefix() {
    return `referralProgram.creation.feedback`;
  }
}
